export default "__VITE_ASSET__0pJmlING__"